import styled from 'styled-components';

export const CookiesInfoContainer = styled.div`
  background-color: white;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 200px;
  padding: 5px 20px 10px 20px;
  text-align: left;
`;

export const CloseButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
